import { render, staticRenderFns } from "./TaskTypeSelector.vue?vue&type=template&id=29671a2e&scoped=true&"
import script from "./TaskTypeSelector.vue?vue&type=script&lang=js&"
export * from "./TaskTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29671a2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29671a2e')) {
      api.createRecord('29671a2e', component.options)
    } else {
      api.reload('29671a2e', component.options)
    }
    module.hot.accept("./TaskTypeSelector.vue?vue&type=template&id=29671a2e&scoped=true&", function () {
      api.rerender('29671a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskType/TaskTypeSelector.vue"
export default component.exports